export default __webpack_public_path__ + "static/media/mutton chap.fd009cd9.jpg";